import React, { Component } from 'react';
import Loader from 'react-loaders';
import { Button } from 'reactstrap';

class ButtonWithLoader extends Component {
  render() {
    return (
      <Button color={this.props.color} 
              className={'loader-button ' + this.props.className} 
              disabled={this.props.disabled || false} 
              onClick={this.props.onClick}
              outline={this.props.outline}>
        {
          this.props.isLoading ? (
            <Loader type="ball-clip-rotate" />
            ) : this.props.text
        }
      </Button>
    );
  }
}

export default ButtonWithLoader;
